
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as geJgzJIPzWRLiPxYh1cp71JhBd23FYL1TfwvO6yX7MT0Meta } from "/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index1nprWbl_458eg7odWkTokykZRKl_iBmy_jdkzy98ni_45V0Meta } from "/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search6XgQekvdv8BT72Qw_URreFlgaF4UZEe4SGx9OydbCx4Meta } from "/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexW05i1u9G9CKYwZGtYBBcd7nfxSkUgW1lfCJdyFQPkRoMeta } from "/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93scaiKIKbtBfiPoKapvmC3qUXhxByhZ1rPGc5_45yfPIWoMeta } from "/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexEggRAeeBtwdptUEY2_ecscOruu_45dWf7L4gjS45TWYRUMeta } from "/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93aQAGjJuDb8feIBkqUD59sRsJYMlBexyY1kfhQuvosiAMeta } from "/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexb2XDPcFW_YRC4FnrwhA4drqycufxjxIEpA0ySktv4UIMeta } from "/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93Xf1_45Z9FjAoQhx2kKJXOSQ3ifhQWS5o9f76hRztllpFsMeta } from "/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexYxM75a_YMe_45Q6Yufoj37Mw36_JdsU0EyWYdJ090JcewMeta } from "/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexF6rBbcF905NIlzHLEOGFNwiuwfGoWlD6GX7CEFdO0l8Meta } from "/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexEggRAeeBtwdptUEY2_ecscOruu_45dWf7L4gjS45TWYRUMeta || {},
    component: () => import("/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexb2XDPcFW_YRC4FnrwhA4drqycufxjxIEpA0ySktv4UIMeta || {},
    component: () => import("/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexYxM75a_YMe_45Q6Yufoj37Mw36_JdsU0EyWYdJ090JcewMeta || {},
    component: () => import("/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexF6rBbcF905NIlzHLEOGFNwiuwfGoWlD6GX7CEFdO0l8Meta || {},
    component: () => import("/codebuild/output/src1822585187/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]